module.exports = __webpack_public_path__ + "assets/images/25B.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25B.png
// module id = 1291
// module chunks = 1